import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CodeImportComponent } from './pages/code-import/code-import.component';

const routes: Routes = [
  { path: 'code-import', component: CodeImportComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule { }
